import ReactMarkdown from 'react-markdown'

// Compact Markdown renderer tuned for chat bubbles. Styles headers, lists,
// inline code, and links to fit inside message bubbles without breaking layout.
export default function Markdown({ children }) {
  return (
    <div className="markdown-chat text-sm whitespace-normal break-words">
      <ReactMarkdown
        components={{
          p: ({ node, ...props }) => <p className="mb-2 last:mb-0 whitespace-pre-wrap" {...props} />,
          h1: ({ node, ...props }) => <h3 className="text-sm font-semibold tracking-[0.05em] uppercase mt-2 first:mt-0 mb-1" {...props} />,
          h2: ({ node, ...props }) => <h4 className="text-sm font-semibold mt-2 first:mt-0 mb-1" {...props} />,
          h3: ({ node, ...props }) => <h5 className="text-xs font-semibold mt-2 first:mt-0 mb-1" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc pl-5 mb-2 last:mb-0 space-y-0.5" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mb-2 last:mb-0 space-y-0.5" {...props} />,
          li: ({ node, ...props }) => <li className="leading-snug" {...props} />,
          strong: ({ node, ...props }) => <strong className="font-semibold" {...props} />,
          em: ({ node, ...props }) => <em className="italic" {...props} />,
          code: ({ node, inline, ...props }) =>
            inline
              ? <code className="font-mono text-[0.8125rem] px-1 py-0.5 rounded bg-black/10" {...props} />
              : <code className="font-mono text-[0.8125rem] block p-2 rounded bg-black/10 overflow-x-auto" {...props} />,
          a: ({ node, ...props }) => <a className="underline" target="_blank" rel="noreferrer" {...props} />,
          blockquote: ({ node, ...props }) => <blockquote className="border-l-2 border-current/30 pl-2 italic mb-2 last:mb-0" {...props} />,
          hr: () => <hr className="my-2 border-current/20" />,
        }}
      >
        {children || ''}
      </ReactMarkdown>
    </div>
  )
}
